import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { ClassificationExampleEdit } from '../ClassificationExampleEdit';

export const Route = createFileRoute('/admin-console/platform-content/ai-training/classification-example/edit/$id')({
    staticData: {
        breadcrumb: { title: 'Edit' },
        ui: { title: 'Edit classification example' },
        presentation: 'overlay',
    },
    component: EditClassificationExample,
});

function EditClassificationExample() {
    const { id } = Route.useParams();
    return (
        <PageController route={Route}>
            <ClassificationExampleEdit mode="edit" id={id} />
        </PageController>
    );
}
